import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { ConfigurationSideBarNavigation } from '../components/configuration-sidebar-navigation';
import { Pages } from '../routing/pages';
import { AppHeader } from './app-header';

const { Sider, Content: LayoutContent } = Layout;

export const ConfigurationLayout = () => {
  return (
    <Layout className='min-h-screen'>
      <AppHeader selectedKey={Pages.CONFIGURATION.link} />
      <Layout className='bg-gray-50'>
        <Sider width={250} className='bg-white shadow-sm' breakpoint='lg' collapsedWidth={0}>
          <ConfigurationSideBarNavigation />
        </Sider>
        <LayoutContent className='p-6'>
          <Outlet />
        </LayoutContent>
      </Layout>
    </Layout>
  );
};
